import {
  getMatchingTableData,
  getMatchingDetail,
  updateMatching,
  changeMatchingStatus,
  delTranslation,
  searchDliteKeyword,
  getTranslationTableData,
  addTranslation,
  editTranslation,
  getTranslationDetail
} from '@/axios/api/newCommentKeywords'

const UPDATE_MATCHING_TABLE_DATA = 'UPDATE_MATCHING_TABLE_DATA'
const UPDATE_MATCHING_PAGER = 'UPDATE_MATCHING_PAGER'
const UPDATE_MATCHING_DETAIL = 'UPDATE_MATCHING_DETAIL'
const UPDATE_TRANSLATION_TABLE_DATA = 'UPDATE_TRANSLATION_TABLE_DATA'
const UPDATE_TRANSLATION_PAGER = 'UPDATE_TRANSLATION_PAGER'
const UPDATE_TRANSLATION_DETAIL = 'UPDATE_TRANSLATION_DETAIL'

const state = {
  matchingTableData: [],
  matchingPager: {
    current: 1,
    size: 10,
    total: 0
  },
  matchingDetail: {},
  translationTableData: [],
  translationPager: {
    current: 1,
    size: 10,
    total: 0
  },
  translationDetail: {}
}

const getters = {
  matchingTableData: state => state.matchingTableData,
  matchingPager: state => state.matchingPager,
  matchingDetail: state => state.matchingDetail,
  translationTableData: state => state.translationTableData,
  translationPager: state => state.translationPager,
  translationDetail: state => state.translationDetail
}

const mutations = {
  [UPDATE_MATCHING_TABLE_DATA] (state, matchingTableData) {
    state.matchingTableData = matchingTableData
  },
  [UPDATE_MATCHING_PAGER] (state, matchingPager) {
    state.matchingPager = { ...state.matchingPager, ...matchingPager }
  },
  [UPDATE_MATCHING_DETAIL] (state, matchingDetail) {
    state.matchingDetail = matchingDetail
  },
  [UPDATE_TRANSLATION_TABLE_DATA] (state, translationTableData) {
    state.translationTableData = translationTableData
  },
  [UPDATE_TRANSLATION_PAGER] (state, translationPager) {
    state.translationPager = { ...state.translationPager, ...translationPager }
  },
  [UPDATE_TRANSLATION_DETAIL] (state, translationDetail) {
    state.translationDetail = { ...state.translationDetail, ...translationDetail }
  }
}

const actions = {
  async getMatchingTableDataApi ({ commit }, params) {
    try {
      const { data: res } = await getMatchingTableData(params)
      commit(UPDATE_MATCHING_TABLE_DATA, res.records)
      commit(UPDATE_MATCHING_PAGER, { total: res.total })
    } catch (e) {}
  },
  async getTranslationTableDataApi ({ commit }, params) {
    try {
      const { data: res } = await getTranslationTableData(params)
      commit(UPDATE_TRANSLATION_TABLE_DATA, res.records)
      commit(UPDATE_TRANSLATION_PAGER, { total: res.total })
    } catch (e) {}
  },
  setMatchingPagerApi ({ commit }, params) {
    commit(UPDATE_MATCHING_PAGER, params)
  },
  setTranslationPagerApi ({ commit }, params) {
    commit(UPDATE_TRANSLATION_PAGER, params)
  },
  async updateMatchingApi ({ commit }, params) {
    try {
      const res = await updateMatching(params)
      return res && res.errorCode === 200
    } catch (e) {
      return false
    }
  },
  async addTranslationApi ({ commit }, params) {
    try {
      const res = await addTranslation(params)
      return res && res.data
    } catch (e) {
      return false
    }
  },
  async editTranslationApi ({ commit }, params) {
    try {
      const res = await editTranslation(params)
      return res && res.data
    } catch (e) {
      return false
    }
  },
  async getMatchingDetailApi ({ commit }, params) {
    try {
      const { data: res } = await getMatchingDetail(params)
      commit(UPDATE_MATCHING_DETAIL, res)
    } catch (e) {}
  },
  async getTranslationDetailApi ({ commit }, params) {
    try {
      const { data: res } = await getTranslationDetail(params)
      commit(UPDATE_TRANSLATION_DETAIL, res)
    } catch (e) {}
  },
  async changeMatchingStatusApi ({ commit }, params) {
    try {
      const res = await changeMatchingStatus(params)
      return res && res.errorCode === 200
    } catch (e) {}
  },
  async delTranslationApi ({ commit }, params) {
    try {
      const res = await delTranslation(params)
      return res && res.errorCode === 200 && res.data !== false
    } catch (e) {}
  },
  async searchDliteKeywordApi ({ commit }, params) {
    try {
      const res = await searchDliteKeyword(params)
      return res.data || []
    } catch (e) {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/newCommentKeywords.js